exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__SocialButtons__root {\n  display: block;\n}\n\n.DS__SocialButtons__Buttons {\n  display: flex;\n  align-items: center;\n}\n\n.DS__SocialButtons__Button + .DS__SocialButtons__Button {\n  margin-left: 8px;\n}\n\n.DS__SocialButtons__Title {\n  display: block;\n  margin-bottom: 12px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #7a869a;\n  letter-spacing: 0.2px;\n}\n\n.DS__SocialButtons__Text {\n  display: block;\n  margin-bottom: 20px;\n}\n\n.DS__SocialButtons__MoreHoriz {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  margin: 0 0 0 8px;\n  cursor: pointer;\n  background-color: transparent;\n  border: 1px solid #eceff5;\n  border-radius: 50%;\n  outline: none;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__SocialButtons__root",
	"Buttons": "DS__SocialButtons__Buttons",
	"Button": "DS__SocialButtons__Button",
	"Title": "DS__SocialButtons__Title",
	"Text": "DS__SocialButtons__Text",
	"MoreHoriz": "DS__SocialButtons__MoreHoriz"
};